// 🔒 본문에 실제로 등장한 멘션 이름 목록 — 번역 요청의 protect (2026-09-04). mentionify 와 같은 매칭(긴 이름 먼저, @ 바로 뒤 접두 일치).
//   nameMap 값(표시명·별칭)만 대상 — 계정 ID 토큰(@gw-…)은 서버의 단일 토큰 보호가 처리한다.
//   🏢 `@@조직명(N명)` 토큰의 조직명도 넣는다(2026-09-10) — 서버는 `@조직명` 을 보호하므로 안쪽 `@장비기술실` 이 가려지고 `(12명)` 만 번역된다.
import { matchDeptMentionAt } from './deptMention';
/**
 * 표시명 하나를 매칭 후보로 편다 — 원본 + 합성형 `"표기 (LATIN NAME)"` 의 각 부분.
 *
 * 🔴 2026-09-19 실사고: 표시명이 `nameWithAlt` 로 `"레 반 구언 (LE VAN QUAN)"` 처럼 합성되는데,
 *    본문 멘션은 `@레 반 구언` 뿐이라 접두 일치가 실패해 **보호 목록에서 빠졌다**.
 *    그 결과 서버는 `@레` 한 토큰만 가리고 남은 "반 구언" 이 번역돼 엉뚱한 낱말이 됐다.
 *    (사용자: "멘션으로 된 별칭·이름이 번역으로 되어 버리네(레 반 구언) → 빵으로 번역")
 *    실제 멤버 이름에서만 뽑으므로 오탐이 늘지 않는다.
 */
function splitCompositeName(n: unknown): string[] {
	const full = String(n || '').trim();
	if (full.length < 2) return [];
	const out = [full];
	const m = /^(.+?)\s*\(([^()]+)\)$/.exec(full);
	if (m) {
		for (const part of [m[1], m[2]]) {
			const p = part.trim();
			if (p.length > 1 && !out.includes(p)) out.push(p);
		}
	}
	return out;
}

export function findMentionNames(text: string, nameMap?: Record<string, string>): string[] {
	if (!text.includes('@')) return [];
	const names = nameMap ? [...new Set(Object.values(nameMap).flatMap(splitCompositeName))].sort((a, b) => b.length - a.length) : [];
	const out: string[] = [];
	let i = 0;
	for (;;) {
		const at = text.indexOf('@', i);
		if (at < 0) break;
		const dt = matchDeptMentionAt(text, at);
		if (dt) { if (dt.label.length > 1 && !out.includes(dt.label)) out.push(dt.label); i = at + dt.length; continue; }
		const rest = text.slice(at + 1);
		const full = names.find((n) => rest.startsWith(n));
		if (full) { if (!out.includes(full)) out.push(full); i = at + 1 + full.length; }
		else i = at + 1;
	}
	return out;
}
